var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"home"},[_c('c-banner'),_c('c-game-play'),_c('c-mobile-video'),_c('c-slider'),_c('c-shop'),_c('c-agatis-info')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }